/**
=========================================================
* Material Dashboard 2 React - Enhanced Chip Styles
=========================================================

* Enhanced chip styling for multiselect components
* Provides professional and sleek appearance
*/

import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { primary, grey, text, white, error } = colors;
const { size } = typography;
const { borderRadius } = borders;

const chip = {
  styleOverrides: {
    root: {
      height: pxToRem(24),
      fontSize: size.xs,
      fontWeight: 500,
      margin: pxToRem(2),
      borderRadius: borderRadius.md,
      
      // Primary chip variant for selected items
      "&.MuiChip-filled": {
        backgroundColor: primary.main,
        color: white.main,
        
        "& .MuiChip-deleteIcon": {
          color: white.main,
          fontSize: pxToRem(16),
          
          "&:hover": {
            color: error.main,
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            borderRadius: "50%",
          },
        },
        
        "&:hover": {
          backgroundColor: primary.focus,
        },
      },
      
      // Outlined variant for count chips
      "&.MuiChip-outlined": {
        backgroundColor: grey[100],
        color: text.main,
        border: `1px solid ${grey[300]}`,
        cursor: "default",
        
        "&:hover": {
          backgroundColor: grey[200],
        },
      },
      
      // Size variants
      "&.MuiChip-sizeSmall": {
        height: pxToRem(20),
        fontSize: size.xxs,
        
        "& .MuiChip-deleteIcon": {
          fontSize: pxToRem(14),
        },
      },
    },
    
    label: {
      padding: `0 ${pxToRem(8)}`,
      lineHeight: 1.2,
      maxWidth: pxToRem(120),
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    
    deleteIcon: {
      marginLeft: pxToRem(4),
      marginRight: pxToRem(-4),
      transition: "all 0.15s ease",
    },
  },
};

export default chip;